

export const CONNECTION_CHANGE_WEBSOCKET_STATUS = 'CONNECTION_CHANGE_WEBSOCKET_STATUS';
export const CONNECTION_PROFILE_LOAD_STATUS = 'CONNECTION_PROFILE_LOAD_STATUS';
export const CONNECTION_UPDATE_STARTUP_EVENTS = 'CONNECTION_UPDATE_STARTUP_EVENTS';


export const changeWebsocketStatus = (readyState) => {
	return {
		type: CONNECTION_CHANGE_WEBSOCKET_STATUS,
		payload: readyState
	}
};

export const updateStartupEvents = (allEvents, activeList) =>{
	return {
		type: CONNECTION_UPDATE_STARTUP_EVENTS,
		payload: {
			all: allEvents,
			remaining: activeList,
		}
	}
};
export const changeProfileStatus = (current, total) => {
	return {
		type: CONNECTION_PROFILE_LOAD_STATUS,
		payload: {
			current: current,
			total: total
		}
	}
};